import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { authAPI } from '../lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/auth');
      return;
    }

    (async () => {
      try {
        const res = await authAPI.exchangeSession(sessionId);
        login(res.data);
        navigate('/dashboard', { state: { user: res.data } });
      } catch (err) {
        console.error('Auth callback error:', err?.response?.data || err.message);
        setError(err?.response?.data?.detail || 'Authentication failed. Please try again.');
        setTimeout(() => navigate('/auth'), 3000);
      }
    })();
  }, [navigate, login]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#020202] flex items-center justify-center">
        <p className="text-red-500 font-mono">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#020202] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF7A3D] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-mono text-[#FF7A3D] text-sm">AUTHENTICATING...</p>
      </div>
    </div>
  );
}
